export enum EventType {
  sport = 'Sport',
  music = 'Music',
  art = 'Art',
  dance = 'Dance',
  food = 'Food or Drink',
  game = 'Gaming',
  market = 'Sales (Flea Market, Auction)',
  history = 'Historical',
  business = 'Business',
  political = 'Political',
  education = 'Education',
}
